module.exports = __webpack_public_path__ + "static/media/Microeconomics_LR.f2111aee.jpg";